import Ajv from 'ajv';
import ajvErrors from 'ajv-errors';
import ajvFormats from 'ajv-formats';
import {
  dateRange,
  digitsRange,
  drillDown,
  maxLength,
  minLength,
  requiredSubtext,
  requiredSubtextMultipleSelection,
} from './keywords';

const _ajv = new Ajv({
  allErrors: true,
  validateSchema: false,
  strictSchema: false,
  strictTuples: false,
  strictRequired: false,
  strictTypes: false,
  formats: {
    date: true,
    email: true,
  },
  unicodeRegExp: false,
  code: {
    es5: true,
  },
});

// ajvの設定の上書き
_ajv.removeKeyword('maxLength');
_ajv.addKeyword(maxLength);

_ajv.removeKeyword('minLength');
_ajv.addKeyword(minLength);

_ajv.addKeyword(digitsRange);
_ajv.addKeyword(dateRange);
_ajv.addKeyword(requiredSubtext);
_ajv.addKeyword(requiredSubtextMultipleSelection);
_ajv.addKeyword(drillDown);

const MAIL_ADDRESS_REGEX =
  /^[a-zA-Z0-9!#$%&'*+\-/=?^_`{|}~]+(?:[.]|[a-zA-Z0-9!#$%&'*+\-/=?^_`{|}~])*[@](?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]+$/;
_ajv.addFormat('email', {
  validate(data: string) {
    return MAIL_ADDRESS_REGEX.test(data);
  },
});

export const ajv = ajvErrors(ajvFormats(_ajv, ['date']));
